import {useEffect, useState} from 'react';

const BOT_JOIN_WAIT_MILLIS = 15_000;

interface AiBotPendingNoticeProps {
    readonly roomId: string;
    readonly busy: boolean;
    readonly onRefresh: () => void;
    readonly onCancel: () => void;
}

export function AiBotPendingNotice({roomId, busy, onRefresh, onCancel}: AiBotPendingNoticeProps) {
    const [delayedRoomId, setDelayedRoomId] = useState<string>();
    useEffect(() => {
        setDelayedRoomId(undefined);
        const timer = window.setTimeout(() => setDelayedRoomId(roomId), BOT_JOIN_WAIT_MILLIS);
        return () => window.clearTimeout(timer);
    }, [roomId]);

    return <>
        <button type="button" disabled={busy} onClick={onCancel} className="text-sm underline">
            Cancel AI invitation
        </button>
        {delayedRoomId === roomId && <span role="status">
            Still waiting for AI bot.{' '}
            <button type="button" disabled={busy} onClick={onRefresh} className="text-sm underline">
                Refresh status
            </button>
        </span>}
    </>;
}
